module.exports = __webpack_public_path__ + "img/1.2af8a7fb.webp";